// Affiliate "Comprar en Ledger" button — replaces the generic "Visitar sitio"
// CTA inside the comparador modal for Ledger products only.
import React from "react";
import { i18nLedger, pickLang } from "../../i18n/ledger-affiliate";

const LEDGER_PATHS = {
  "ledger-nano-s-plus": "ledger-nano-s-plus",
  "ledger-nano-x": "ledger-nano-x",
  "ledger-stax": "ledger-stax",
  "ledger-flex": "ledger-flex",
};

const LedgerComparadorBtn = ({ walletId, lang = "es" }) => {
  const L = ["es", "en", "sk", "de", "zh-CN"].includes(lang) ? lang : "en";
  const path = LEDGER_PATHS[walletId];
  if (!path) return null;
  return (
    <a
      href={`https://shop.ledger.com/products/${path}?r=eb740c0da9e0&tracker=comparador_wallets`}
      target="_blank"
      rel="noopener noreferrer sponsored"
      data-testid={`ledger-comparador-btn-${walletId}`}
      className="mt-5 inline-flex items-center gap-2 rounded-xl px-5 py-2.5 text-xs font-black uppercase tracking-widest text-black"
      style={{
        background: "linear-gradient(135deg, #f5a623, #e8941a)",
        boxShadow: "0 4px 18px rgba(245,166,35,0.35)",
      }}
    >
      {pickLang(i18nLedger.comprarEn, L)}
    </a>
  );
};

export default LedgerComparadorBtn;
